import Vue from 'vue';
import store from './custom-apps/store/newsroom';


// init app
const VueApp = new Vue({
    store,
});

export { VueApp as default };